import React, { Component } from "react"
import { connect } from "react-redux"

import ClusterEditItemTopics from "./ClusterEditItemTopics"
import { clusterTopicEditSelect } from "../../../../actions/cluster-actions"
import { autocompleteConceptsRequest } from "../../../../actions/autocomplete-actions"

class ClusterEditItemConceptsContainer extends Component {
    state = { searchTerm: "", isFetchingSearch: false, searchResults: [] }

    componentDidUpdate(prevProps) {
        if (this.props.concepts.length !== prevProps.concepts.length) {
            this.setState({
                searchResults: this.state.searchResults.map(concept => ({
                    ...concept,
                    isAdded: this.props.concepts.some(
                        ({ id }) => id === concept.id
                    )
                }))
            })
        }
    }

    onSearch = event => {
        const searchTerm = event.target.value
        this.setState({ searchTerm, isFetchingSearch: !!searchTerm })
        this.props.onSearch(
            searchTerm,
            (_, { searchTerm: retrievedSearchTerm, options: data }) => {
                if (this.state.searchTerm === retrievedSearchTerm) {
                    this.setState({
                        isFetchingSearch: false,
                        searchResults: data.map(concept => ({
                            ...concept,
                            isAdded: this.props.concepts.some(
                                ({ id }) => concept.id === id
                            )
                        }))
                    })
                }
            }
        )
    }

    onApply = () => {
        this.setState({
            searchTerm: "",
            isFetchingSearch: false,
            searchResults: []
        })
    }

    render() {
        return (
            <ClusterEditItemTopics
                {...this.props}
                onSearch={this.onSearch}
                onApply={this.onApply}
                {...this.state}
            />
        )
    }
}

const mapDispatchToProps = dispatch => ({
    onSearch: (searchTerm, callback) =>
        dispatch(autocompleteConceptsRequest(searchTerm, callback)),
    onSelect: (name, concept) => dispatch(clusterTopicEditSelect(name, concept))
})

export default connect(
    null,
    mapDispatchToProps
)(ClusterEditItemConceptsContainer)
